import api from "./Api";

class AtualizacaoPlanoService {
  GetAtualizacaoPlano(payload) {
    return api.get("/v1/atualizacaoPlano/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAtualizacaoPlano(payload) {
    return api.post("/v1/atualizacaoPlano/", payload).then((response) => {
      return response.data;
    });
  }

  PutAtualizacaoPlano(payload) {
    return api.put("/v1/atualizacaoPlano/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAtualizacaoPlano(payload) {
    return api.delete("/v1/atualizacaoPlano/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAtualizacaoPlanoOData(payload) {
    return api.get("/OData/AtualizacaoPlano" + payload).then((response) => {
      return response.data;
    });
  }

  PostAtualizacaoPlanoConfirmarPlano(payload) {
    return api
      .post("/v1/AtualizacaoPlano/confirmarPlano/", payload)
      .then((response) => {
        return response.data;
      });
  }

  PostAtualizacaoPlanoCancelarPlano(payload) {
    return api
      .post("/v1/AtualizacaoPlano/cancelarPlano/" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new AtualizacaoPlanoService();
